<template>
    <v-container class="main-container">
        <v-expansion-panels class="exp-margins">
            <v-expansion-panel>
            <v-expansion-panel-header>Dina personuppgifter</v-expansion-panel-header>
            <v-expansion-panel-content>
                <MyProfile v-if="!loading" :client="booking.client" />
            </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
            <v-expansion-panel-header>Karta till boendet</v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-row v-if="!loading" align="center" justify="center">
                    <v-img
                    :src="booking.booking_entity.frontend.google_maps.static_link"
                    aspect-ratio="1"
                    class="grey lighten-2"
                    max-width="500"
                    max-height="300"
                    ></v-img>
                </v-row>
            </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
            <v-expansion-panel-header>Ditt hyreskontrakt</v-expansion-panel-header>
            <v-expansion-panel-content>
                <div v-if="!loading">
                    <iframe :src="booking.contract_link" style="background-color: white; width:100%; height: 800px;"></iframe>
                </div>
            </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
            <v-expansion-panel-header>Allmänna villkor och hyresvillkor</v-expansion-panel-header>
            <v-expansion-panel-content>
                <h3>Allmänna villkor för uthyrning av stugor, hus och lägenheter. Antagna av Föreningen Sverigeturism
1990 efter överläggningar med Konsumentverket. Om förmedlaren tillämpar särskilda villkor, har
dessa tryckts med kursiv stil nedan.</h3>
                <p>Som Förmedlare är vi skyldiga att:</p>
                <ul>
                    <li>1. du får en skriftlig bekräftelse på din bokning</li>
                    <li>2. du får handlingar och uppgift om hur nycklar eller kodlås fungerar till bostaden</li>
                    <li>3. stugan/lägenheten stämmer med beskrivningen</li>
                    <li>4. du informeras om alla väsentliga förändringar som rör din bokning</li>
                    <li>5. du får disponera stugan, huset eller lägenheten från kl 15.00 avtalad ankomstdag till kl 09.00 i fjällen och 11.00 Spanien avresedagen, om inget annat bekräftats.</li>
                </ul>
                <p style="font-weight: bold;">Om du har några invändningar med boendet, så är det oss du skall vända dig till.</p>
                <h4>När blir min bokning bindande?</h4>
                <p>I samband med din bokning skickades en bekräftelse ut. Du ombads där att fylla i dina uppgifter och ladda upp kopia på ditt pass/legitimation. När du accepterade kontraktet och dessa allmänna villkor är bokningen bekräftad och bindande.</p>
                <h4>När skall jag betala?</h4>
                <p>I kontraktet presenteras de slutgiltiga datumen för när dels handpenning men också slutbetalning ska ske</p>
                <h4>Vad händer om jag inte betalar i tid?</h4>
                <p>Ifall handpenningen inte betalas i tid kommer en påminnelse att skickas ut. Ifall handpenningen ej har betalats trots påminnelse så har vi rätt att stryka din bokning</p>
                <h4>Vad gäller om jag vill avboka?</h4>
                <p>Du kan avboka muntligen eller skriftligen till oss. Avbokningen räknas inte om den görs till någon annan. Vi är skyldiga att bekräfta din avbokning skriftligen. Om du avbokar tidigare än 60 dagar före avtalad ankomst så försöker vi hitta en ny hyresgäst som tar din plats och endast handpenningen går förlorad. Görs avbokning mindre än 30 dagar för ankomst försöker vi också hitta en ny hyresgäst. I det fall vi inte lyckas med detta så behöver hyrestagare betala hela kontraktssumman. Om vi lyckas hyra ut stugan/lägenheten till någon annan, återbetalar vi till dig hela beloppet minus handpenning.</p>
                <h4>Men om det händer mig något?</h4>
                <p>Du kan skydda dig mot avbeställningskostnaden genom att köpa ett avbeställningsskydd. Se Gouda men vi rekommenderar att ni använder Er hemförsäkring</p>
                <h4>Vad har jag för rättigheter?</h4>
                <p>Om vi inte tillhandahåller
stugan/lägenheten i utlovat skick eller vid rätt tidpunkt och inte klarar av att erbjuda dig en annan
stuga/lägenhet, vars skillnader mot den du bokade är så små att de saknar betydelse för dig, så har
du rätt att säga upp hyresavtalet. Vi måste då betala allt det du betalat oss och ersätta dig för dina
styrkta och rimliga kostnader, med avdrag för den nytta du kan ha haft av stugan/lägenheten. I stället
för att säga upp hyresavtalet, kan du begära att vi sätter ned hyran. Om du har klagomål bör du
framföra dem till oss direkt, dock inom 1 dag från ankomstdagen. Fel som uppstår under vistelsen
bör du anmäla omgående, så att vi får en chans att rätta till det. Du har rätt att sätta någon annan i
ditt ställe och vi måste godta den personen om vi inte har särskilda skäl att vägra.</p>
                <h4>Vad har jag för skyldigheter?</h4>
                <p>Du måste vårda stugan/lägenheten väl och följa de ordningsregler, anvisningar och
bestämmelser som gäller. Du som beställare har själv ansvar för alla skador, som uppstår på
fastigheten och dess inventarier, genom att du eller någon annan i ditt sällskap varit vårdslös. Du får
inte använda stugan/lägenheten till något annat än vad som avtalades vid bokningen (vanligtvis
fritidsändamål / semesterändamål) och du får inte låta fler personer övernatta i stugan/lägenheten
eller på tomten, än vad du uppgav vid bokningen. Vid självhushåll utan städservice ankommer det på
dig att städa ordentligt före avresa. Vid bristande städning har vi rätt att utföra städning á 2500 kr på
din bekostnad. I det fall ägaren säljer objektet och ny ägare tar vid skall alla bokningar inom 3 månader automatiskt ingå i köpeavtalet mellan parterna och ej röras. Den nya ägaren har rätten att
säga upp hyresgäster efter tre månaders regeln och återbetalning av eventuell handpenning skall då
göras. Vid en försäljning skall alla parter verka för att de hyresgäster som berörs av tre månaders
regeln får bibehålla sin bokning alternativt hitta ett likvärdigt boende.</p>
                <h3>Avtalet upphör att gälla med omedelbar verkan om</h3>
                <p>
                    <ul>
                        <li>1. Du eller någon i ditt sällskap uppträder störande i stugan/ lägenheten/området.</li>
                        <li>2. Du eller någon i sällskapet begår skadegörelse i stugan/Lägenheten/området.</li>
                        <li>3. Boendet används till ej avsett ändamål.</li>
                    </ul>
                </p>
                <h3>Krig, naturkatastrofer, strejker mm</h3>
                <p>
Hyresavtalet kan komma att brytas ifall objektet inte kan tillhandahållas på
grund av krigshandlingar, naturkatastrofer, arbetsmarknadskonflikt, längre avbrott i vatten- och
energitillförseln, eldsvåda eller andra liknande större händelser, som varken du eller vi kunnat
förutse eller påverka. Vi är i så fall skyldiga att fortast möjligt betala tillbaka vad du betalat, med
avdrag för den nytta du haft av stugan/ lägenheten. </p>
                <h4>Ovan villkor gäller för hyresgäster av
stuga/lägenhet enligt upprättat avtal.</h4>
            </v-expansion-panel-content>
            </v-expansion-panel>
            
            <v-expansion-panel>
            <v-expansion-panel-header>Betalningsinformation</v-expansion-panel-header>
            <v-expansion-panel-content v-if="!loading">
                <p>Betalning sker till Bankkonto {{ booking.booking_entity.payment_bank_bank }} {{ booking.booking_entity.payment_bank_account }}</p>
                <p>Alternativt till Swish på nummer {{ booking.booking_entity.payment_swish }}</p>
                <p>Ange <strong>{{ booking.public_id }}</strong> som referens vid betalning</p>
            </v-expansion-panel-content>
            </v-expansion-panel>
            
        </v-expansion-panels>
        
  
        <v-row>
            <v-row v-if="loading">
                <v-card
                class="mx-auto"
                
                >
                Bokningen laddas...
                </v-card>
            </v-row>
            <v-container v-else-if="booking" fluid>
                <v-row dense>
                    <v-col>
                    <v-card
                    class="mx-auto"
                    
                    >
                        <v-img
                        class="white--text"
                        height="200px"
                        :src="booking.booking_entity.frontend.image_url"
                        >
                            <v-card-title style="color:black;" class="align-end fill-height">{{ booking.booking_entity.name }}</v-card-title>
                        </v-img>

                        <v-card-text>
                            <span class="text--primary">
                                <span>{{ booking.booking_entity.descr }}</span><br>
                                <span>{{ booking.booking_entity.address }}</span><br>
                                <span>{{ booking.booking_entity.location1 }}</span><br>
                                <span>{{ booking.booking_entity.location2 }}</span><br>
                            </span>
                            <span class="text--primary" style="font-weight: bold;">
                                <br/>
                                <span>
                                Nycklar och dörrkod: {{ booking.booking_entity.pincode }}
                                </span><br>
                                <span>
                                WiFi: {{ booking.booking_entity.wificode }}
                                </span>
                            </span>
                        </v-card-text>

                    </v-card>
                </v-col>
                <v-col >
                    <v-card
                    class="mx-auto"
                    >
                        <v-card-text>
                            <v-form>
                                <v-subheader>Bokningsuppgifter</v-subheader>

                                <v-row>
                                    <v-col
                                    cols="12"
                                    md="12"
                                    >

                                        <v-text-field
                                        v-model="booking.public_id"
                                        label="Bokningsnummer"
                                        readonly
                                        color="black"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                    cols="6"
                                    md="6"
                                    >
                                        <v-text-field
                                        v-model="booking.booked_entry"
                                        label="Tillträde"
                                        readonly
                                        color="black"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                    cols="6"
                                    md="6"
                                    >
                                        <v-text-field
                                        v-model="booking.booking_entity.checkin"
                                        label="Tidigast"
                                        readonly
                                        color="black"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                    cols="6"
                                    md="6"
                                    >
                                        <v-text-field
                                        v-model="booking.booked_exit"
                                        label="Utträde"
                                        readonly
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                    cols="6"
                                    md="6"
                                    >
                                        <v-text-field
                                        v-model="booking.booking_entity.checkout"
                                        label="Senast"
                                        readonly
                                        color="black"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col
                                    cols="4"
                                    md="4"
                                    >
                                    
                                        <v-text-field
                                        v-model="booking.invoice_downpay.to_pay"
                                        label="Handpenning (SEK)"
                                        readonly
                                        color="black"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col 
                                        cols="4"
                                        md="4">
                                        <v-icon v-if="!booking.invoice_downpay.is_payed" color="red darken-2">mdi-alert-circle-outline</v-icon>
                                        <v-icon v-if="booking.invoice_downpay.is_payed" color="green darken-2">mdi-thumb-up</v-icon>
                                    </v-col>
                                    <v-col 
                                        cols="4"
                                        md="4">
                                        <v-text-field
                                        v-if="!booking.invoice_downpay.is_payed"
                                        v-model="booking.invoice_downpay.due"
                                        label="Betala innan"
                                        readonly
                                        color="black"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                    cols="4"
                                    md="4"
                                    >
                                        <v-text-field
                                        v-model="booking.invoice_fullpay.to_pay"
                                        label="Slutbetalning (SEK)"
                                        readonly
                                        color="black"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col 
                                        cols="4"
                                        md="4">
                                        <v-icon v-if="!booking.invoice_fullpay.is_payed" color="red darken-2">mdi-alert-circle-outline</v-icon>
                                        <v-icon v-if="booking.invoice_fullpay.is_payed" color="green darken-2">mdi-thumb-up</v-icon>
                                    </v-col>
                                    <v-col 
                                        cols="4"
                                        md="4">
                                        <v-text-field
                                        v-if="!booking.invoice_fullpay.is_payed"
                                        v-model="booking.invoice_fullpay.due"
                                        label="Betala innan"
                                        readonly
                                        color="black"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-col>
                
            </v-row>
            </v-container>
            
            <v-container v-if="!loading" fluid grid-list-lg>
                <v-layout row wrap 
                    v-for="(item, i) in upsells"
                    :key="i">
                    <v-flex xs12>
                    <v-card>
                        <v-container fluid grid-list-lg>
                        <v-layout row>
                            <v-flex xs9>
                            <div>
                                <div class="subheading font-weight-medium">
                                {{ item.descr }}
                                </div>
                                <div>
                                
                                </div>
                                <v-row no-gutters>
                                <v-col
                                    cols="12"
                                    sm="4"
                                >
                                    
                                    <span>{{ item.amount }} kr/st</span>
                                    
                                </v-col>

                                <v-col v-if="item.has_quantity"
                                    cols="12"
                                    sm="4"
                                >
                                    
                                    <span>Ange Antal:</span>
                                    
                                </v-col>
                                <v-col v-if="item.has_quantity"
                                    cols="12"
                                    sm="4"
                                >
                                    
                                    <v-text-field v-model="item.quantity" @change="calcTotal(i)" v-bind:label="qtyLabel(item.min_quantity, item.max_quantity)" ></v-text-field>
                                    
                                </v-col>
                                </v-row>
                                <v-row no-gutters>
                                <v-col v-if="item.has_quantity"
                                    cols="12"
                                    sm="12"
                                >
                                    
                                    <v-text-field v-model="item.total" disabled></v-text-field>
                                    
                                </v-col>
                                </v-row>
                                
                                <div style="margin-top: 20px;">
                                    <v-btn v-if="!item.purchased" rounded color="primary" @click="purchaseUpsell(item)">LÄGG TILL</v-btn>
                                    <v-btn v-if="item.purchased" color="secondary" @click="cancelUpsell(item.upsell_id)">AVBESTÄLL</v-btn>
                                </div>
                            </div>
                            </v-flex>
                            <v-flex xs3>
                            <v-img
                                contain
                                :src="item.image_url"
                                height="72px"
                                transition="false"
                            ></v-img>
                            </v-flex>
                        </v-layout>
                        </v-container>
                    </v-card>
                    </v-flex>

                </v-layout>
            </v-container>
        </v-row>
    </v-container>
</template>


<script>
import MyProfile from "./MyProfile";

export default {
  created(){
        if (this.$route.params.alias) {
            this.$store.commit('changeBookingLoading', true);
            this.$store.dispatch('setBookingByAlias', this.$route.params.alias);
        }
        else if (this.$route.params.booking_id) {
            this.$store.commit('changeBookingLoading', true);
            const booking_id = this.$route.params.booking_id
            this.$store.dispatch('getBookingPublic', booking_id)
        }
        else if (localStorage.getItem('booking_id')) {
            this.$store.dispatch('getBookingPublic', localStorage.getItem('booking_id'));
        }
        
  },
  components: {
      MyProfile
  },
  computed: {
    static_urls() {
        return this.$store.state.static_urls;
    },
    booking() {
        let booking = this.$store.getters.publicBooking;

        this.upsells = [];
        for (var i = 0; i < booking.upsells.length; ++i) {
            this.upsells.push(booking.upsells[i]);
            if (this.upsells[i].purchased) {
                this.upsells[i].total = parseInt(this.upsells[i].quantity) * parseInt(this.upsells[i].amount);
            }
            else {
                this.upsells[i].quantity = 1;
                this.upsells[i].total = parseInt(this.upsells[i].quantity) * parseInt(this.upsells[i].amount);
            }
        }

        return booking;
    },
    loading() {
        return this.$store.getters.bookingLoading
    },
  },
  data() {
    return {
       upsells: []
    };
      
  },
  watch: {
      upsells: function() {
          for (var i = 0; i < this.upsells.length; ++i) {
            
            if (this.upsells[i].purchased) {
                this.upsells[i].total = parseInt(this.upsells[i].quantity) * parseInt(this.upsells[i].amount);
            }
            else {
                this.upsells[i].quantity = 1;
                this.upsells[i].total = parseInt(this.upsells[i].quantity) * parseInt(this.upsells[i].amount);
            }
        }
      }
  },
  methods: {
      calcTotal(i) {
        let upsell = this.upsells[i];

        if (upsell.has_quantity) {
            
            upsell.total = parseInt(upsell.quantity) * parseInt(upsell.amount);
            this.upsells[i].total = parseInt(upsell.quantity) * parseInt(upsell.amount);
            return upsell.quantity * upsell.amount;
        }

        this.upsell.total = parseInt(upsell.amount);

        return upsell.amount;
      },
      qtyLabel(min_qty, max_qty) {
          return min_qty + ' - ' + max_qty;
      },
      purchaseUpsell(upsell) {
          var payload = { booking_id: this.$store.getters.publicBooking.booking_id, upsell_id: upsell.upsell_id, quantity: parseInt(upsell.quantity) };

          this.$store.dispatch('purchaseUpsell', payload);
          
      },
      cancelUpsell(upsell_id) {
          var payload = { booking_id: this.$store.getters.publicBooking.booking_id, upsell_id: upsell_id };

          this.$store.dispatch('cancelUpsell', payload);
      }

  }
}
</script>

<style scoped>

.amount-order span {
    margin-top: 10px;
}
.subheading {
    margin-bottom: 20px;
}
.amt-left {
    width: 100px;
    float: left;
}
.amt-right {
    width: 200px;
    float: left;
}
.exp-margins {
    margin-bottom: 20px;
}
.v-text-field {
    margin-top: 0px !important;
    padding-top: 0px !important;
}
.main-container {
    margin-top: 80px;
}
</style>